import { TICKETS_RECEIVED_PERIOD_DAYS } from '@easyhelp/shared';
import { formatDateTime } from '../format';

/** Ultimo token emesso: istante o «mai». */
export function lastTokenLabel(lastTokenAt: string | null): string {
  return lastTokenAt ? formatDateTime(lastTokenAt) : 'Mai';
}

/** Ticket ricevuti nel periodo; `null` se il conteggio non è disponibile. */
export function ticketsReceivedLabel(count: number | null): string {
  if (count === null) return 'Non disponibile';
  return `${count} in ${TICKETS_RECEIVED_PERIOD_DAYS} giorni`;
}
